import React, { useEffect } from "react"

import { useTranslation } from "react-i18next"
import CRUD from "../core/genericCRUD/CRUD"
import { parsedUser } from "../../common/GetCurrentUser"

const AdminEmpresasRASADEPComponent = (props: any) => {
  const [t] = useTranslation("global")
  const user = parsedUser()

  return (<>
    <CRUD
      isModal={false}

      id="empresas"
      cssClass="modalRight"
      showModal={props.show}
      toggleCRUD={props.toggle}
      filterOpen={true}
      title={t("Empresas / RASADEP") ?? ""}
      icon={"fas fa-building"}
      recordButtonsPosition="start"
      getRecordsPath={`estructuraCompania/list`}
      getRecordsMethod="post"
      addEditRecordPath={`estructuraCompania/AddEdit?currentUserId=${user.ID}`}
      deleteRecordPath="estructuraCompania/delete"
      filterFields={[


        {
          name: "estructuraId",
          htmlType: "select",
          dbType: "string",
          title: "Estructura",
          containerClass: "col-12 col-md-4",
          required: false,
          dataSource: "estructura/list",
          dataSourceTextField: "nombre",
          dataSourceValueField: "id",
          datasourceMethod: "POST",
        },

      ]}
      fieldsList={[
        {
          name: "identificador",
          title: t("RNC "),
          htmlType: "text"
        },
        {
          name: "nombre",
          title: t("Nombre / Razón Social"),
        },
        {
          name: "estructuraNombre",
          title: t("Estructura")
        }


      ]}
      fields={[
        { name: "id", htmlType: "hidden", dbType: "string" },
        { name: "identificador", required: true, htmlType: "searchRNC", dbType: "string", title: t("RNC") ?? "", containerClass: "col-12 col-md-6" },
        {
          name: "nombre", htmlType: "search", dbType: "string", title: t("Nombre") ?? "", containerClass: "col-12 col-md-6",
          dataSourceTextField: "name",
          dataSourceValueField: "id",
          dataSource: "dgii/list",
          datasourceMethod: "GET",
        },


        {
          name: "estructuraId",
          htmlType: "select",
          dbType: "string",
          title: "Estructura",
          containerClass: "col-12 col-md-6",
          required: false,
          dataSource: "estructura/list",
          dataSourceTextField: "nombre",
          dataSourceValueField: "id",
          datasourceMethod: "POST",
        },
        { name: "detalles", htmlType: "textarea", dbType: "string", title: t("Detalles") ?? "", containerClass: "col-12 " },
      ]}
    />
  </>
  )
}

export default AdminEmpresasRASADEPComponent
